import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { DEVICE_ALERT_ROUTE_SORT_COLUMNS, DEVICE_ALERT_SORT_COLUMNS, DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS } from './-constants';
export const deviceAlertSearchFields = {
  ...dataGridSearchFields,
  pageIndex: z.number().int().nonnegative().catch(0),
  freeText: z.string().optional(),
  deviceGroupId: z.string().optional(),
  ruleId: z.string().optional()
};
export const DeviceAlertsSearchSchema = z.object({
  ...deviceAlertSearchFields,
  sortColumn: z.enum(DEVICE_ALERT_ROUTE_SORT_COLUMNS).optional()
});
export const DeviceAssignmentAlertsSearchSchema = z.object({
  ...deviceAlertSearchFields,
  sortColumn: z.enum(DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS).optional()
});
export const DeviceAlertListSearchSchema = z.object({
  ...deviceAlertSearchFields,
  sortColumn: z.enum(DEVICE_ALERT_SORT_COLUMNS).optional()
});
export type DeviceAlertsSearch = z.infer<typeof DeviceAlertsSearchSchema>;
export function resetDeviceAlertSearchForCategoryNavigation(search: DeviceAlertsSearch): DeviceAlertsSearch {
  return {
    ...search,
    pageIndex: 0,
    sortColumn: undefined,
    sortOrder: undefined
  };
}